import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {HcaMemberService} from '../../../../../../shared/_services/hca-member.service';
import {UtilService} from '../../../../../../shared/_services/util.service';

@Component({
  selector: 'app-members-subscription-history-list',
  templateUrl: './members-subscription-history-list.component.html',
  styleUrls: ['./members-subscription-history-list.component.scss']
})
export class MembersSubscriptionHistoryListComponent implements OnInit {
  historyList: any[] = [];
  totalCount = 0;
  p = 1;
  size = 10;
  loading = false;
  searchForm: FormGroup;
  canViewHistory = false;
  canViewHardDeleteAudit = false;

  constructor(
    private hcaMemberService: HcaMemberService,
    public utilService: UtilService
  ) {}

  ngOnInit() {
    this.canViewHistory = this.hasHistoryAccess();
    this.canViewHardDeleteAudit = this.hasHardDeleteAuditAccess();
    this.searchForm = new FormGroup({
      searchTerm: new FormControl('')
    });
    if (this.canViewHistory) {
      this.loadHistory(0);
    }
  }

  hasHistoryAccess(): boolean {
    const user = JSON.parse(localStorage.getItem('loggedInUser'));
    if (!user || !user.token) {
      return false;
    }
    const role = this.utilService.parseJwt(user.token).info.roles;
    return ['ROLE_CC', 'ROLE_CCS', 'ROLE_HCA', 'ROLE_LSA'].indexOf(role) >= 0;
  }

  hasHardDeleteAuditAccess(): boolean {
    const user = JSON.parse(localStorage.getItem('loggedInUser'));
    if (!user || !user.token) {
      return false;
    }
    const role = this.utilService.parseJwt(user.token).info.roles;
    return ['ROLE_HCA', 'ROLE_CCS'].indexOf(role) >= 0;
  }

  loadHistory(page: number) {
    this.loading = true;
    const term = this.searchForm ? this.searchForm.get('searchTerm').value : '';
    this.hcaMemberService.searchSubscriptionStatusHistory(page, term).subscribe(res => {
      this.loading = false;
      if (res.error === 0 && res.responseObj) {
        this.historyList = res.responseObj.results || [];
        this.totalCount = res.responseObj.totalRecords || 0;
      } else {
        this.historyList = [];
        this.totalCount = 0;
      }
    }, () => {
      this.loading = false;
      this.historyList = [];
      this.totalCount = 0;
    });
  }

  search() {
    this.p = 1;
    this.loadHistory(0);
  }

  pageChanged(event: number) {
    this.p = event;
    this.loadHistory(event - 1);
  }

  formatMovementDate(timestamp: number): string {
    return this.utilService.dateFormat(timestamp, 'MMM DD, YYYY hh:mm:ss A');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/members/members-management/members-subscription-history-list/members-subscription-history-list.component.ts